import Alpine from 'alpinejs'

Alpine.data('product360', (video) => ({
    
    state: {
        isPlaying: false,
        videoDuration: null,
        panStartWasPlaying: false,
        panStartVideoTime: 0,
        panStartPosition: null,
        scrubWidth: 0,
        scrubPixelPerSecond: 0,
        hasTrackedScrub: false,
    },
    
    init() {
        const self = this
        video.addEventListener('loadedmetadata', () => {
            self.state.videoDuration = video.duration
            self.state.scrubWidth = self.$el.offsetWidth
            self.state.scrubPixelPerSecond = self.state.scrubWidth/self.state.videoDuration
        })
        video.addEventListener('timeupdate', () => {
            self.state.videoDuration = video.duration
            self.state.scrubWidth = self.$el.offsetWidth
            self.state.scrubPixelPerSecond = self.state.scrubWidth/self.state.videoDuration
        })
        this.$watch('state.isPlaying', value => {
            this.$dispatch(value ? 'video-started' : 'video-stopped')
        })
    },
    start() {
        video.play()
            .then(() => this.state.isPlaying = true)
    },
    stop() {
        video.pause()
        this.state.isPlaying = false
    },
    toggle() {
        if(this.state.isPlaying) {
            this.stop()
        } else {
            this.start()
        }
    },
    resize() {
        this.state.scrubWidth = this.$el.offsetWidth
    },    
    panStart(position) {
        if(this.state.videoDuration === null) {
            return
        }
        this.state.panStartPosition = position
        this.state.panStartVideoTime = video.currentTime
        this.state.panStartWasPlaying = this.state.isPlaying
        this.stop()
    },
    panMove(position) {
        if(this.state.panStartPosition === null || this.state.videoDuration === null) {
            return
        }
        const scrubDistance = this.state.panStartPosition-position
        const timeDistance = scrubDistance / this.state.scrubPixelPerSecond
        let newVideoTime = this.state.panStartVideoTime + timeDistance
        newVideoTime = newVideoTime % this.state.videoDuration 
        video.currentTime = newVideoTime < 0
            ? this.state.videoDuration + newVideoTime
            : newVideoTime
        
        if(!this.state.hasTrackedScrub && Math.abs(scrubDistance) > 100) {
            window.gtag('event', 'product_360_scrub')
            this.state.hasTrackedScrub = true
        }
    },
    panEnd(position) {
        if(this.state.panStartPosition === null) {
            return
        }
        const scrubDistance = Math.abs(this.state.panStartPosition-position)
        this.state.panStartPosition = null
        
        // detect a click be pan-start/end with low distance
        
        if(scrubDistance < 2) {
            if(this.state.panStartWasPlaying) {
                this.stop()
            } else {
                this.start()
            }
        }
    },
}))